<script>
  import DesignTools from '../components/DesignTools.svelte'

  export let data
  export let showEdit
  export let blocksConfig
  export let user
  let showSettings = false;

  function setCurrent(type) {
    document.querySelector('#blocks').style.display = 'block'

    document.querySelectorAll('.box').forEach(el => {
      el.style.display = 'none'
    })
    document.querySelectorAll('.' + type).forEach(el => {
      el.style.display = 'block'
    })
  }

  function clear() {
    var result = confirm('Are you sure remove all blocks and start over?')
    if (result) {
      localStorage.removeItem('json')
      localStorage.removeItem('design')
      data.title = ''
      data.entries = []
      data.header = {
        layout: '',
        title: 'My Website',
        tagline: 'Powered by Sitefiction',
        image: '',
        fields: 'title,body,image',
      }
      data.footer = ''
      data = data

      showEdit = false

      location.reload()
    }
  }

  function saveMe(){
    document.querySelector('#save').click();
    showSettings = false
  }
</script>

<label>Add Content Blocks</label>
<ul class="list-group cats">

  {#each blocksConfig.categories as cat}
    {#if cat == 'headers'}
      <li class="list-group-item">
        <div class="blocks-cat" on:click={() => setCurrent(cat)}>{cat}</div>
      </li>
    {:else}
      <li class="list-group-item">
        <div class="blocks-cat" on:click={() => setCurrent(cat)}>{cat}</div>
      </li>
    {/if}
  {/each}

</ul>

<div class="mob-hide">

  <DesignTools bind:data />

{#if user}

<label class="mt-4">Website Settings</label>
  <button class="btn btn-outline-secondary w-100" id="clear" on:click={() => showSettings = true}>
    <i class="fa fa-cog" />
    Settings
  </button>

   {#if showSettings}
    <div class="backdrop">
    <div class="window">

      <div class="header">
        <div class="close" on:click={() => showSettings = false}>&times;</div>
        <img
          src="/assets/img/sitefiction-banner.png"
          class="img-fluid"
          alt="login/register" />
      </div>
        <div id="settings" class="content">

   <h4 class="mt-0">Website Settings</h4>
<label class="mt-4">Title</label>
  <ul class="list-group">
  <input class="form-control" placeholder="My Website" bind:value={data.title}>
  </ul>

  <label>Description</label>
  <ul class="list-group">
  <input class="form-control" bind:value={data.description}>
  </ul>

 

         <button class="btn btn-outline-dark mt-4" on:click="{saveMe}">Save</button>
        </div>
        </div></div>
      {/if}

  {:else}

  <label class="mt-4">Start Over</label>
  <button class="btn btn-outline-secondary w-100" id="clear" on:click={clear}>
    <i class="fa fa-times" />
    Clear
  </button>

  {/if}

</div>





<svelte:head>
	<title>{data.title}</title>
</svelte:head>